import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, filter } from "rxjs";
import { IGoal, IGoalNode } from "@gtmhub/goals/models";

@Injectable()
export class GoalTreeService {
  private selectedGoal$: BehaviorSubject<IGoal> = new BehaviorSubject<IGoal>(null);

  public setSelectedGoal(goalNode: IGoalNode): void {
    this.selectedGoal$.next(goalNode?.goal || null);
  }

  public getSelectedGoal$(): Observable<IGoal> {
    return this.selectedGoal$.asObservable().pipe(filter((selectedGoal) => selectedGoal !== null));
  }
}
